// Add your custom JS here.

jQuery( document ).ready(function() {
   
  jQuery('.logo-slidar').slick({
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 7,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    centerMode: false,
    focusOnSelect: true,
    dots: false,
    variableWidth: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
// Slick slidar js end


jQuery('.testimonial-full-width-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  adaptiveHeight: true,
  });

jQuery(window).scroll(function(){
    if(jQuery(this).scrollTop() > 100){
        jQuery('.navigation-menu').addClass('sticky')
    } else{
        jQuery('.navigation-menu').removeClass('sticky')
    }
});

jQuery(".navbar-toggler").click(function(){
  jQuery("body").toggleClass("menu-open");
});

jQuery(".menu-item-has-children > a").after('<span class="arrow-icon"></span>');
  jQuery(".arrow-icon").click(function() {
    jQuery(this).parent().toggleClass("menu-open");
      jQuery(this).next().toggleClass("drop-open");
  });


  (function( $ ) {
    $.fn.tabConvert = function(options) {
      
      var settings = $.extend({
        activeClass: "active",
        screenSize: 767,
      }, options );
  
      return this.each(function(i) {
        var wrap = $(this).wrap('<div class="tab-to-dropdown"></div>'),
            currentItem = $(this),
            container = $(this).closest('.tab-to-dropdown'),
            value = $(this).find('.'+settings.activeClass).text(),
            toggler = '<div class="selected-tab">'+ value +'</div>';
        currentItem.addClass('converted-tab');
        container.prepend(toggler);
        
        // function to slide dropdown
        function tabConvert_toggle(){
          currentItem.parent().find('.converted-tab').slideToggle();
        }
  
        container.find('.selected-tab').click(function(){
          tabConvert_toggle();
        });
        
        currentItem.find('li').click(function(e){
          var windowWidth = window.innerWidth;
          if( settings.screenSize >= windowWidth){
            tabConvert_toggle();
            var selected_text = $(this).text();
            $(this).closest('.tab-to-dropdown').find('.selected-tab').text(selected_text);
          }
        });
        
        //Remove toggle if screen size is bigger than defined screen size
        function resize_function(){
          var windowWidth = window.innerWidth;
          if( settings.screenSize >= windowWidth){
            currentItem.css('display','none');
            currentItem.parent().find('.selected-tab').css('display','');
          }else{
            currentItem.css('display','');
            currentItem.parent().find('.selected-tab').css('display','none');
          }
        }
        resize_function();
        
        $(window).resize(function(){
          resize_function();
        });
        
      });
    };
  
    // 	Toggle will appear on default screen size 767px
    jQuery('.faq-section .faq-navigation').tabConvert({
    activeClass: "active",
    });
    
  
  }( jQuery ));

});


// FAQ
jQuery(window).scroll(function() {
var windscroll = jQuery(window).scrollTop();
if (windscroll >= 100) {
  jQuery('.scrollable').each(function(i) {
    if (jQuery(this).position().top <= windscroll + 300) {
      jQuery('.faq-navigation li.active').removeClass('active');
      jQuery('.faq-navigation li').eq(i).addClass('active');
    }
  });

} else {
  jQuery('.faq-navigation li.active').removeClass('active');
  jQuery('.faq-navigation li:first').addClass('active');
}

}).scroll();

jQuery(".faq-navigation li a").click(function(){
var href = jQuery(this).attr( 'href' );
jQuery( 'html, body' ).animate({
  scrollTop: jQuery( href ).offset().top - 100
}, '300' );
e.preventDefault();

jQuery(".faq-navigation li").removeClass("active");
jQuery(this).parent().addClass("active");
});


setInterval(function(){
if(document.activeElement instanceof HTMLIFrameElement){
    const placeholderImg = document.querySelector('.placeholder-img');
    if (placeholderImg) {
        placeholderImg.style.opacity = 0; 
    }
    const parentElement = document.querySelector('.ifrme-video');
    if (parentElement) {
        const iframe = parentElement.querySelector('iframe');
        if (iframe) {
            iframe.style.opacity = 1;
        }
    }
}
}, 50);


jQuery(document).ready(function () {
setTimeout(function(){
  jQuery('.ifrme-video iframe').css("opacity", "1");
}, 200);
setTimeout(function(){
  jQuery('.ifrme-video iframe').css("opacity", "0");
}, 250);
});

jQuery (window).ready (function () {
setTimeout (function () {
  jQuery ('#modal-subscribe').modal ("show")
}, 5000)
})